export const API_PROJECTS_LAST_SECTION_FIELDS = [
    'project_first_type.last_section_first_type.id',
    'project_first_type.last_section_first_type.languages_code',
    'project_first_type.last_section_first_type.bottom_right_image.id',
    'project_first_type.last_section_first_type.top_left_image.id',
    'project_first_type.last_section_first_type.work_details_image.id',
    'project_first_type.last_section_first_type.projects_number_desc_component'
];
